import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Subscription} from "../../../core/models/subscription.model";

@Component({
  selector: 'app-onboarding-subscription-card',
  templateUrl: './onboarding-subscription-card.component.html',
  styleUrls: ['./onboarding-subscription-card.component.scss']
})
export class OnboardingSubscriptionCardComponent {

  @Output() selected = new EventEmitter<Subscription>();

  private _subscription!: Subscription;
  private _isSelected: boolean = false;
  private _isExpanded = false;


  get subscription(): Subscription {
    return this._subscription;
  }

  @Input({required: true})
  set subscription(value: Subscription) {
    this._subscription = value;
  }


  get isSelected(): boolean {
    return this._isSelected;
  }
  @Input({required: true})
  set isSelected(value: boolean) {
    this._isSelected = value;
  }

  get isExpanded(): boolean {
    return this._isExpanded;
  }

  toggleDescription() {
    this._isExpanded = !this.isExpanded;
  }

  selectSubscription() {
    this.selected.emit(this.subscription)
  }
}
